//import '../../styles/Form.css';
import "es6-shim";
import * as React from 'react';
import { ILabelSelect } from '../../services/Language/Types';
import { SelectControl } from '../FormControls/SelectControl';

interface IFormInputProps {
    id: string,
    labelText: string,
    typeOfInput?: string,
    value: string | number,
    placeHolder?: string,
    readOnly?: boolean,
    required?: boolean
    customInput?: JSX.Element
    fontSize?: number,
    validationMessage?: string,
    isInvalid?: boolean,
    defaultValue?: string,
    options: ILabelSelect[],
    noOptionsMessage?:string;
    onClick?(): void,
    onBlur?(): void,
    onChange?(value: string | number): void,
}

export class LabelledSelect extends React.Component<IFormInputProps, any> {
    constructor(props: Readonly<IFormInputProps>) {
        super(props);
    }
    public render() {
        const labelClass = "input-label";
        return (
            <div className="input-container" style={{ textAlign: "left" }}>
                <label className={labelClass}>{this.props.labelText}</label>
                <div>
                    {
                        <SelectControl
                            isInvalid={this.props.isInvalid}
                            options={this.props.options}
                            value={this.props.value}
                            onChange={(value) => this.props.onChange(value)}
                            placeholder={this.props.placeHolder}
                            noOptionsMessage={this.props.noOptionsMessage}
                        />
                    }
                </div>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/customFormComponents/LabelledSelect.tsx